module.exports = __webpack_public_path__ + "static/media/LaLibertad.a0a142eb.jpg";